import { H1 } from 'src/components/common/typography/Header';
import { media } from 'src/styles/designs';
import styled from 'styled-components';

export const EventPageHeading = styled(H1).attrs({ as: 'h2' })`
  display: flex;
  flex-direction: column;
  justify-content: center;

  min-height: 60px;

  ${media.w.lessThan.desktop} {
    padding-left: 40px;
  }
`;
